import React from "react";
import PropTypes from "prop-types";
import { withStyles, Snackbar, Tooltip } from "@material-ui/core";
import { connect } from "react-redux";
import { styles } from "./DownloadLink.css";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Button from "@material-ui/core/Button";
import { Translation } from "react-i18next";
import { Menu, MenuItem, CircularProgress } from "@material-ui/core";
import { _PermittedContent } from "./../../_module/utils/PermittedContent";
import { BiLock, BiDownload } from "react-icons/bi";
import { TbFileBroken } from "react-icons/tb";
import {
  updateDownloads,
  getDownloadLink,
  getDownloadBookletLink,
} from "../../redux/actions/DownloadActions";
import Confirm from "../Confirm";
import { activityLimitActions } from "../UserActivityLimit";
import { DownloadResolutions } from "../../modules/ml-downloader/downloader/Downloader";
import GetAppIcon from "@material-ui/icons/GetApp";
import { FaFilePdf } from "react-icons/fa";
import clsx from "clsx";
import { MdDownload } from "react-icons/md";
import {formatBytes} from "./../../util/CommonFunc";



export const DownloadLinkDisplayMode = {
  Booklet: "booklet",
  Progress: "progress",
  Ready: "ready",
  NotAvailable: "notAvailable",
  Available: "available",
  NoPermission: "noPermission",
};

export const AssetNotFoundReason = {
  notrack: "notrack",
  exception: "exception",
  noClearance: "noClearance",
  noPermission: "noPermission",
  noAsset: "noAsset",
};

class DownloadLink extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
      abuseMsg: null,
      abuseFlag: null,
      errorMessage: null,
      assetLinks: null,
    };
  }

  handleClick = (event) => {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => this.setState({ anchorEl: null });

  handleCloseAbuseMsg = (event) => {
    const {
      isMenuItem,
      closeFunction
    } = this.props;

    event.stopPropagation();

    if (isMenuItem && closeFunction)
      closeFunction();

    activityLimitActions(this.state.abuseFlag);
    this.setState({ abuseMsg: null, abuseFlag: null });
  };

  messageTimeout = null;
  showError = (errorMessage) => {
    clearTimeout(this.messageTimeout);
    this.setState({ errorMessage });
    this.messageTimeout = setTimeout(() => {
      this.setState({ errorMessage: null });
    }, 8000);
  };

  evaluation = (done) => {
    const {
      track,
      download: { trackDownloads, tracksDownloading },
      setDownloads,
      cfId,
      plId,
      cfTrackSequenceId
    } = this.props;

    if (track) {
      if (!trackDownloads.has(track.id) && !tracksDownloading.includes(track.id)) {
        setDownloads({ id: track.id, ...(plId && { plId: plId }), ...(cfId && { cfId: cfId }), ...(cfTrackSequenceId && { cfTrackSequenceId: cfTrackSequenceId }) },
          () => this.setState({ assetLinks: this.getAssetLinks(track) })
        );
      }
      else {
        this.setState({ assetLinks: this.getAssetLinks(track) })
      }
    }
  };

  getAssetLinks = () => {

    const {
      track,
      download: { trackDownloads },
    } = this.props;

    var originalAsset = trackDownloads?.get(track?.id)?.links?.find((a) => a.quality === 0);

    return trackDownloads?.get(track?.id)?.links?.map((r) => ({
      ...r,
      name: `${track?.trackTitle}.${r.type}`,
      label: r.quality === 0 ? `${r.type} (${r.size > 0 ? formatBytes(r.size) : r.size})` : (r.quality === 1 ? `${r.type} ${originalAsset ? "(encoded from " + originalAsset.type + ")" : ""}` : (r.quality === 2 ? `Broadcast WAV Format` : r.type)),
  })) ?? [];
  }

  getAssetNotFoundReason = () => {
    const {
      track,
      download: { trackDownloads },
    } = this.props;

    switch (trackDownloads?.get(track?.id)?.reason)
    {
      case AssetNotFoundReason.notrack:
        return "Audio downloads: Track not found";
      case AssetNotFoundReason.exception:
        return "Audio downloads: Exception";
      case AssetNotFoundReason.noClearance:
        return "Audio downloads: No clearance";
      case AssetNotFoundReason.noPermission:
        return "Audio downloads: No permission";
        default:
        return "Audio downloads: No asset";
    }
  }

  componentDidUpdate(prevProps) {
    const { track } = this.props;
    if (track?.id !== prevProps?.track?.id) {
      this.setState({ anchorEl: null });
    }
  };

  getCanDownloadHires = (item, track) => {
    const {
      orgRuntime: {
        runtime: {
          _mlPlayer,
          _canDownloadHighres,
        }
      }
    } = this.props;

    let permission = _PermittedContent([_mlPlayer, _canDownloadHighres], []);

    return this.isDownloadPermission(permission, item, track);
  };

  getCanDownloadLores = (item, track) => {
    const {
      orgRuntime: {
        runtime: {
          _mlPlayer,
          _canDownloadMp3, }
      }
    } = this.props;

    let permission = _PermittedContent([_mlPlayer, _canDownloadMp3], []);

    return this.isDownloadPermission(permission, item, track);

  };

  isDownloadPermission = (permission, item, track) => {
    const {
      orgRuntime: {
        runtime: {
          _canDownloadOptions,
        }
      }
    } = this.props;

    switch (permission) {
      case _canDownloadOptions.all.id:
        return true;
      case _canDownloadOptions.none.id:
        return false;
      case _canDownloadOptions.noRestricted.id:
        return track?.restricted ||
          item?.restricted ||
          this.getIsRestrictedcTag(item, ["RES"])
          ? false
          : true;
      case _canDownloadOptions.noRestrictedUnclear.id:
        return track?.restricted ||
          item?.restricted ||
          this.getIsRestrictedcTag(track, ["RES"]) ||
          this.getIsRestrictedcTag(item, ["RES"])
          ? false
          : true;
    case _canDownloadOptions.noSD.id:
      return this.getIsRestrictedcTag(track, ["STOPD"]) || this.getIsRestrictedcTag(item, ["STOPD"]) ? false : true;
    case _canDownloadOptions.noRestrictedOrSD.id:
        return track?.restricted ||
          item?.restricted ||
          this.getIsRestrictedcTag(track, ["RES"]) ||
          this.getIsRestrictedcTag(track, ["STOPD"]) ||
          this.getIsRestrictedcTag(item, ["RES"]) ||
          this.getIsRestrictedcTag(item, ["STOPD"])
          ? false
          : true;
    case _canDownloadOptions.noRestrictedOrSDUnclear.id:
      return track?.restricted ||
        item?.restricted ||
        this.getIsRestrictedcTag(track, ["RES"]) ||
        this.getIsRestrictedcTag(track, ["STOPD"]) ||
        this.getIsRestrictedcTag(item, ["RES"]) ||
        this.getIsRestrictedcTag(item, ["STOPD"])
        ? false
        : true;
    case _canDownloadOptions.noUnclear.id:
      return true;
    default:
      return false;
  }};

  getIsRestrictedcTag = (item, tags = []) => {
    if (item?.cTagList?.length > 0) {
      let res = item.cTagList.find(
        (v) => tags.includes(v.indicator) && v.result
      );
      return res ? true : false;
    } else {
      return false;
    }
  };

  render() {

    const {
      classes,
      track,
      showBooklet,
      showAutoMessage,
      download: { trackDownloads, tracksDownloading },
      cfTrackSequenceId,
      isMenuItem,
      anchorOrigin,
      closeFunction,
      cfId,
      plId,
      item,
      //plUserPermission,
      //downloadType,
      //orgRuntime: {
      //runtime: {
      //  _mlPlayer,
      //}
      //}
    } = this.props;
    const { anchorEl, assetLinks } = this.state;
    var isTrackDownloading = tracksDownloading.includes(track?.id);
    let canDownloadLowRes = this.getCanDownloadLores(item, track);
    let canDownloadHiRes = this.getCanDownloadHires(item, track);

    var isPermission = (canDownloadHiRes == true || canDownloadLowRes == true);

    // if (downloadType && downloadType === PlayableTypes.playlist) {
    //   if (plUserPermission == true) {
    //     isPermission = true;
    //   }
    //   else if (plUserPermission == null) {
    //     if (track && _PermittedContent(_mlPlayer)) {
    //       isPermission = true;
    //     }
    //   }
    // }
    // else {
    //   if (_PermittedContent(_mlPlayer)) {
    //     isPermission = true;
    //   }
    // }

    var isLoaded = trackDownloads.has(track?.id);
    var _assetLinks = [];

    if (isPermission) {
      _assetLinks = assetLinks?.length > 0 ? assetLinks : this.getAssetLinks();
      if (track?.prodBookletUrl && showBooklet) {
        _assetLinks.push({ label: `downloader.res_${DownloadResolutions.high}`, dummyElement: true }, { label: `downloader.res_${DownloadResolutions.low}`, dummyElement: true });
      }
    }

    var isAssetLinks = _assetLinks?.length > 0;

    var downloadAssetAvailable = track?.highResAudio === true || track?.lowResAudio === true;

    var downloadLinkDisplayMode = DownloadLinkDisplayMode.Ready;

    if (!track || (isPermission && ((isLoaded && !isTrackDownloading && !isAssetLinks) || !downloadAssetAvailable))){
      downloadLinkDisplayMode = DownloadLinkDisplayMode.NotAvailable;
    }
    else if (!isTrackDownloading && !isPermission) {
      downloadLinkDisplayMode = DownloadLinkDisplayMode.NoPermission;
    }
    else if (track?.prodBookletUrl && showBooklet) {
      downloadLinkDisplayMode = DownloadLinkDisplayMode.Booklet;
    }
    else if (isPermission && isTrackDownloading) {
      downloadLinkDisplayMode = DownloadLinkDisplayMode.Progress;
    }
    else if (isPermission && downloadAssetAvailable && !isLoaded && !isTrackDownloading) {
      downloadLinkDisplayMode = DownloadLinkDisplayMode.Ready;
    }
    else if (isPermission && downloadAssetAvailable && isLoaded && !isTrackDownloading && isAssetLinks) {
      downloadLinkDisplayMode = DownloadLinkDisplayMode.Available;
    }

    var evaluatable = (isPermission && !isTrackDownloading && downloadAssetAvailable);

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <Snackbar
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              open={this.state.errorMessage ? true : false}
              message={this.state.errorMessage}
              className={classes.snackbar}
            />
            <Confirm
              name="abuseDialog"
              classes
              isOpen={this.state.abuseMsg ? true : false}
              title="Warning"
              innerHtmlContent={this.state.abuseMsg}
              confirm="OK"
              onConfirm={(e) => this.handleCloseAbuseMsg(e)}
            />
            {isMenuItem ? (
              <Tooltip placement="right-end" title={t("libraryPreview.downloads")}>
                <MenuItem
                id={`context-${t("libraryPreview.downloads").toLowerCase().replace(/\s+/g, "-")}-${track?.id}`}
                
                  aria-label={t("libraryPreview.downloads")}
                  aria-controls="action"
                  aria-haspopup="true"
                  onClick={(event) => {
                    if (!evaluatable) return;
                    this.handleClick(event);
                    this.evaluation();
                  }}
                >
                  <GetAppIcon className={classes.contextIcons} />{" "}
                  Downloads&nbsp;&nbsp;&nbsp;{" "}
                  {(() => {
                    switch (downloadLinkDisplayMode) {
                      case DownloadLinkDisplayMode.Progress:
                        return (<CircularProgress size={20} className={classes.preLoader} />);
                      case DownloadLinkDisplayMode.NotAvailable:
                        return (<TbFileBroken title={this.getAssetNotFoundReason()} className="" style={{ marginLeft: "auto", fontSize: 17 }} />);
                      case DownloadLinkDisplayMode.NoPermission:
                        return (<BiLock title="Audio downloads: No permission" className="noPermission" style={{ marginLeft: "auto" }} />);
                      default:
                        return null;
                    }
                  })()}
                </MenuItem>
              </Tooltip>
            ) : (
              <Button
                type="button"
                variant="contained"
                color="inherit"
                component="span"
                aria-label={t("libraryPreview.downloads")}
                className={clsx(classes.buttons, "downloadButton")}
                aria-controls="action"
                aria-haspopup="true"
                onClick={(event) => {
                  if (!evaluatable) return;
                  this.handleClick(event);
                  this.evaluation();
                }}
              >
                {(() => {
                  switch (downloadLinkDisplayMode) {
                    case DownloadLinkDisplayMode.Booklet:
                      return (<MoreVertIcon />);
                    case DownloadLinkDisplayMode.Progress:
                      return (<CircularProgress size={20} className={classes.preLoader} />);
                    case DownloadLinkDisplayMode.Ready:
                      return (<BiDownload title={t("libraryPreview.downloads")} />);
                    case DownloadLinkDisplayMode.NotAvailable:
                      return (<TbFileBroken style={{fontSize:"15px"}}  title={this.getAssetNotFoundReason()} />);
                    case DownloadLinkDisplayMode.NoPermission:
                      return (<BiLock title="Audio downloads: No permission" className="noPermission" style={{ marginLeft: "auto" }} />);
                    case DownloadLinkDisplayMode.Available:
                      return (<BiDownload title={t("libraryPreview.downloads")} />);
                    default:
                      return null;
                  }
                })()}
              </Button>
            )}
            {(_assetLinks.length > 0 || (track?.prodBookletUrl && showBooklet)) && (
              <Menu
                keepMounted
                getContentAnchorEl={null}
                anchorOrigin={{
                  horizontal: isMenuItem
                    ? anchorOrigin
                      ? anchorOrigin
                      : "right"
                    : "left",
                  vertical: "bottom",
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                {_assetLinks.sort((a, b) => a.quality - b.quality).map((assetLink) => (

                  <MenuItem
                  id={`context-${assetLink.label.toLowerCase().replace(/\./g, "-").replace(/[()]/g, "").replace(/\s+/g, "-")}-${track?.id}`}
                    disabled={assetLink.dummyElement || false}
                    onClick={(e) => {
                      e.stopPropagation();

                      if (assetLink.dummyElement) return;

                      this.handleClose();
                      if (!isMenuItem && closeFunction) closeFunction();
                      getDownloadLink(track?.id, assetLink, track?.searchId, plId, cfId, cfTrackSequenceId).then((res) => {
                        if (res.abuseFlag)
                          this.setState({
                            abuseMsg: res.abuseMsg,
                            abuseFlag: res.abuseFlag,
                          });
                        else if (isMenuItem && closeFunction)
                          closeFunction();

                        if (res.url) {
                          var link = document.createElement("a");
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          link.href = res.url;
                          link.download = res.filename;
                          document.body.appendChild(link);
                          link.click();
                          window.URL.revokeObjectURL(link);
                          link.remove();
                        } else {
                          if (showAutoMessage && !res.url) {
                            showAutoMessage(
                              "Sorry, requested download is not available"
                            );
                          } else {
                            this.showError(
                              "Sorry, requested download is not available"
                            );
                          }
                        }
                      });
                    }}
                  >
                    {assetLink.dummyElement
                      ? <BiLock style={{ marginLeft: "0", marginRight: "5px", fontSize: "17px" }} />
                      : <MdDownload className={classes.iconContext} />
                    } {assetLink.label}

                  </MenuItem>

                ))}

                {track?.prodBookletUrl && showBooklet &&
                  <MenuItem
                    onClick={() => {
                      this.handleClose();
                      getDownloadBookletLink(track?.id, track?.prodBookletUrl).then((res) => {
                        if (res.url) {
                          var link = document.createElement("a");
                          link.target = "_blank";
                          link.rel = "noopener noreferrer";
                          link.href = res.url;
                          link.download = res.name;
                          document.body.appendChild(link);
                          link.click();
                          window.URL.revokeObjectURL(link);
                          link.remove();
                        } else {
                          this.showError(
                            "Sorry, requested download is not available"
                          );
                        }
                      });

                    }}
                  >
                    <FaFilePdf className={classes.iconContext} /> Download booklet
                  </MenuItem>
                }
              </Menu>
            )}
          </>
        )}
      </Translation>
    );
  }
}

DownloadLink.propTypes = {
  classes: PropTypes.object.isRequired,
  track: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDownloads: (payload, done = null) => dispatch(updateDownloads(payload, done)),
  };
};

const mapStateToProps = (state) => ({
  download: state.download,
  orgRuntime: state.orgRuntime,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DownloadLink));
